import React from "react";

import { SpinnerAnimation, SpinnerContainer, SpinnerIcon } from "./styles";

export type SpinnerProps = {
  className?: string;
  height?: string;
  size?: number;
};

export const Spinner = ({ className, height, size = 64 }: SpinnerProps) => {
  const classes = `${className} spinner-container`;

  return (
    <SpinnerContainer
      className={classes}
      height={height}
      aria-busy="true"
      role="alert"
      aria-label="loading"
      data-testid="spinner"
    >
      <SpinnerAnimation dimensions={size} className="spinner-ring">
        <SpinnerIcon dimensions={size} className="spinner" />
      </SpinnerAnimation>
    </SpinnerContainer>
  );
};
